import { SUPPLEMENTARY_FEATURE_NAME } from './reducer';

export class SupplementarySelector {
    static selectMessageTypes(state) {
        return state[SUPPLEMENTARY_FEATURE_NAME].messageTypes;
    }
}
